import React from 'react';

const Alert = (props) => <div className="Alert">
  {props.children}
</div>;

export default Alert;


// WEBPACK FOOTER //
// ./src/components/Alert.js